module.exports = __webpack_public_path__ + "dcc27bffa89de7ce8bb02d673398320c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-34.png
// module id = 121
// module chunks = 0